import { render, staticRenderFns } from "./OrdersCharts.vue?vue&type=template&id=321129b0&"
import script from "./OrdersCharts.vue?vue&type=script&lang=js&"
export * from "./OrdersCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports